module.exports = __webpack_public_path__ + "media/images/lp/industries/cta-2b21b121cab0da6ce881ff073395370d.svg";